import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import OurEdge from "./pages/OurEdge";
import Nursing from "./pages/Nursing";
import Jobs from "./pages/Jobs";
import Telehealth from "./pages/Telehealth";
import PhysiciansAdvanced from "./pages/PhysiciansAdvanced";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-edge" element={<OurEdge />} />
          <Route path="/nursing" element={<Nursing />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/telehealth" element={<Telehealth />} />
          <Route path="/physicians-advanced" element={<PhysiciansAdvanced />} />
        </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
